import { List, Record as record } from 'immutable';
import { construct, fields } from '../helpers/LinkMapper';

const defaults = {
    activeStep: 0,
    steps: new List(),
};

class Stepper extends record(defaults) {

    static fromJSON(json = {}) {
        return construct(Stepper, json, {
            activeStep: fields.number,
            steps: new List(defaults)
        });
    }

    setActiveStep (step) {
        return this.set('activeStep', step);
    }

    handleNextStep () {
        return this.set('activeStep', this.activeStep + 1);
    }

    handlePrevStep () {
        return this.set('activeStep', this.activeStep - 1);
    }
}

export default Stepper;



// WEBPACK FOOTER //
// ./src/records/Stepper.js